<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                        <div>
                            <SportipsButton @onClick="$router.back()" chevronLeft>Retour</SportipsButton>
                        </div>
                        <div class="d-flex flex-column ga-2">
                            <div class="text-h5 font-weight-bold text-darkblue">Créer une campagne email
                            </div>
                            <div>Cette interface vous permet de créer une campagne email.
                            </div>
                            <BreadCrumbs class="mb-4"></BreadCrumbs>
                            <CampaignConfiguration v-if="campaignStore.current_step == 1"></CampaignConfiguration>
                            <EmailContent v-if="campaignStore.current_step == 2"></EmailContent>

                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import BreadCrumbs from "@/components/Administration/MailingSystem/CreateCampaign/BreadCrumbs.vue";
import CampaignConfiguration from "@/components/Administration/MailingSystem/CreateCampaign/CampaignConfiguration.vue";
import EmailContent from "@/components/Administration/MailingSystem/CreateCampaign/EmailContent.vue";
import { useCampaignStore } from "@/stores/mailingSystem/campaignStore";
import { mapStores } from "pinia";
export default {
    components: { BreadCrumbs, CampaignConfiguration, EmailContent },
    computed: {
        ...mapStores(useCampaignStore),
    },
    mounted() {
        this.campaignStore.current_step = 1;
        this.campaignStore.name = "test";
        this.campaignStore.id_contacts_list = 2;
        this.campaignStore.subject = "test";
        this.campaignStore.pre_header = "test";
    }
}
</script>

<style lang="scss" scoped></style>